<script>
  import { scale } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  export let show = false;
  export let isQuestion = false;
  export let isSuccess = false;
  export let isFail = false;
  export let title = "";
  const dispatch = createEventDispatcher();
  const onClose = () => {
    dispatch("modalClose");
  };
</script>

{#if show}
  <div
    on:click|self={onClose}
    class="fixed top-0 left-0 bottom-0 right-0 flex items-center justify-center bg-black/50 px-32"
    style="z-index: 1000;"
  >
    <div
      transition:scale
      class="relative w-full bg-gray-100 rounded-lg shadow-2xl px-6 overflow-auto"
      style="height: 95vh !important;"
    >
      <button
        class="btn btn-secondary absolute top-2 right-6"
        on:click={onClose}
      >
        <i class="fas fa-times-circle mr-3" />
        Close Window
      </button>
      <div class="mb-4">
        <slot><!-- optional fallback --></slot>
      </div>
    </div>
  </div>
{/if}
